import { createHashRouter, Navigate } from 'react-router-dom'
import { ErrorBoundary } from '@clofo/ui/error-boundary'
import { LoginPage } from './pages/login'
import { ForgotPasswordPage } from './pages/forgot-password'

const router = createHashRouter([
  {
    path: '/',
    element: (
      <ErrorBoundary>
        <LoginPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'passwords/forgot',
    element: (
      <ErrorBoundary>
        <ForgotPasswordPage />
      </ErrorBoundary>
    ),
  },

  /**
   * Test pages (logged-in placeholder and fake SSO identity provider), only available in
   * development or testing
   */
  ...(import.meta.env.DEV
    ? [
        {
          path: 'dev-logged-in',
          lazy: async () => {
            const { DevLoggedInPage } = await import('./pages/dev-logged-in')
            return {
              element: (
                <ErrorBoundary>
                  <DevLoggedInPage />
                </ErrorBoundary>
              ),
            }
          },
        },
        {
          // Fake IdP page the mock generate_auth_url handler points the SSO popup at — the path
          // here and the URL in mocks/handlers.ts must stay in sync.
          path: 'dev-sso',
          lazy: async () => {
            const { DevSsoPage } = await import('./pages/dev-sso')
            return {
              element: (
                <ErrorBoundary>
                  <DevSsoPage />
                </ErrorBoundary>
              ),
            }
          },
        },
      ]
    : []),
  {
    path: '*',
    element: <Navigate to='/' replace />,
  },
])

export default router
